import { render, staticRenderFns } from "./daily-office-top.vue?vue&type=template&id=58dd5399&scoped=true"
import script from "./daily-office-top.vue?vue&type=script&lang=js"
export * from "./daily-office-top.vue?vue&type=script&lang=js"
import style0 from "./daily-office-top.vue?vue&type=style&index=0&id=58dd5399&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd5399",
  null
  
)

export default component.exports